import { openDB, IDBPDatabase } from 'idb';
import { MobilePhotoDTO } from '../Photos/MobilePhotosScreen';

export const DB_NAME = 'StavarioIDb';
export const DB_VERSION = 1;
export const STORE_NAME = 'MobilePhotosQueue';

export function getQueueKey(buildingId: number): string {
    return `imageQueue_${buildingId}`;
}

export async function getDB(): Promise<IDBPDatabase> {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        },
    });
}

export async function loadQueueFromIDB(buildingId: number): Promise<MobilePhotoDTO[]> {
    try {
        const db = await getDB();
        const key = getQueueKey(buildingId);
        const queue = await db.get(STORE_NAME, key);
        return queue || [];
    } catch (e) {
        console.error('Error loading image queue from IndexedDB', e);
        return [];
    }
}

export async function saveQueueToIDB(queue: MobilePhotoDTO[], buildingId: number): Promise<void> {
    try {
        const db = await getDB();
        const key = getQueueKey(buildingId);
        await db.put(STORE_NAME, queue, key);
    } catch (e) {
        console.error('Error saving image queue to IndexedDB', e);
    }
}
